import LocalStorageService from "../../localStorage-service";
import ApiService from "../../App/services/APIService";

export const SizeActionTypes = {
    SET_ACTIVE_SIZE: 'CHANGE_ACTIVE_SIZE',
};
export const FiguresTypes = {
    SET_FIGURES: 'SET_FIGURES',
};
export const GraphActionTypes = {
    SET_GRAPH: 'SET_GRAPH'
}

export const PreviewSymbolActionTypes = {
    SET_ACTIVE_PREVIEW_SYMBOL: 'SET_ACTIVE_PREVIEW_SYMBOL'
};

export const SelectedSymbolToTable = {
    SET_SELECTED_SYMBOL: 'SET_SELECTED_SYMBOL'
};
export const RemoveSelectedSymbolToTable = {
    REMOVE_SELECTED_SYMBOL: 'REMOVE_SELECTED_SYMBOL'
};
export const SchematicList = {
    SET_NEW_SCHEMATIC_ELEMENT: 'SET_NEW_SCHEMATIC_ELEMENT',
    CLEAR_SCHEMATIC_ELEMENTS: 'SET_NEW_SCHEMATIC_ELEMENTS',
    REFRESH_SCHEMATIC_ELEMENTS: 'REFRESH_SCHEMATIC_ELEMENTS'
}
export const SymbolTypes = {
    SET_SYMBOL_TYPES: 'SET_SYMBOL_TYPES'
}
export const ImportJsonStatus = {
    SET_IMPORT_JSON_STATUS: 'SET_IMPORT_JSON_STATUS'
}

export const SideBarVisibility = {
    SET_SIDEBAR_VISIBILITY: 'SET_SIDEBAR_VISIBILITY'
}
export const SchematicDocument = {
    SET_SCHEMATIC_DOCUMENT: 'SET_SCHEMATIC_DOCUMENT',
}
export const LogOut = {
    SET_LOG_OUT: 'SET_LOG_OUT'
}

export const Loading = {
    SET_LOADER: 'SET_LOADER',
    REMOVE_LOADER: 'REMOVE_LOADER',
}
export const Draft = {
    SET_DRAFT: 'SET_DRAFT'
}
export const Background = {
    SET_BACKGROUNDS: 'SET_BACKGROUNDS'
}
export const Types = {
    SET_SCHEMATIC_TYPE: 'SET_SCHEMATIC_TYPE'
}

export function setActiveSchematicType(activeSchematicType) {
    return {type: Types.SET_SCHEMATIC_TYPE, activeSchematicType}
}

export function setBackgrounds(backgrounds) {
    return {type: Background.SET_BACKGROUNDS, backgrounds}
}

export function createDraft(schematicTypeId) {
    return function (dispatch) {
        dispatch(setLoader('New Schematic...'));
        schematicTypeId = schematicTypeId || LocalStorageService.getSchematicTypeId();
        return ApiService.createDraft(schematicTypeId).then(res => {
            const {document_name, data} = res;
            dispatch(setDraft({document_name, data}));
            LocalStorageService.setSchematic(res);
            dispatch(removeLoader('New Schematic...'));
        })
    };
}

export function recreateSchematicsTabs(pageElements) {
    return function (dispatch, getState) {
        const symbolElements = [];
        let background = null;
        pageElements.forEach(element => {
            if (element.isBackground) {
                background = element;
            } else if (element.type === 'Symbol' && !element.isSpecial) {
                symbolElements.push(element);
            }
        });
        const symbolsList = getState().schematicReducers.symbolsTypes[0].symbols;
        const addedElements = [];
        symbolElements.forEach(item => {
            const equalEl = symbolsList.find(c => c.id === item.symbolTypeId);
            if (!addedElements.some(s => s.id === equalEl.id)) {
                addedElements.push(equalEl);
            }
        });
        dispatch(refreshSchematicListElements(addedElements));
    };
}

export function setDraft(draft) {
    return {type: Draft.SET_DRAFT, draft}
}

export function setLoader(loader) {
    return {type: Loading.SET_LOADER, loader}
}

export function removeLoader(loader) {
    return {type: Loading.REMOVE_LOADER, loader}
}

export function setLogOut() {
    return {type: LogOut.SET_LOG_OUT}
}

export function setSymbolTypes(symbolTypes) {
    return {type: SymbolTypes.SET_SYMBOL_TYPES, symbolTypes}
}

export function setSchematicListElement(schematicUpdated) {
    return {type: SchematicList.SET_NEW_SCHEMATIC_ELEMENT, schematicUpdated}
}

export function refreshSchematicListElements(schematicUpdated) {
    return {type: SchematicList.REFRESH_SCHEMATIC_ELEMENTS, schematicUpdated}
}

export function clearSchematicListElements() {
    return {type: SchematicList.CLEAR_SCHEMATIC_ELEMENTS}
}

export function selectSymbol(symbol) {
    return {type: FiguresTypes.SET_FIGURES, symbol};
}

export function setActivePreviewSymbol(symbol) {
    return {type: PreviewSymbolActionTypes.SET_ACTIVE_PREVIEW_SYMBOL, symbol};
}

export function setActiveSize(gridStep) {
    return {type: SizeActionTypes.SET_ACTIVE_SIZE, gridStep};
}

export function setGraph(graph) {
    return {type: GraphActionTypes.SET_GRAPH, graph}
}

export function setSelectedSymbolToTable(selectedSymbol) {
    return {type: SelectedSymbolToTable.SET_SELECTED_SYMBOL, selectedSymbol}
}

export function setRemoveSelectedSymbolToTable(removedSymbol) {
    return {type: RemoveSelectedSymbolToTable.REMOVE_SELECTED_SYMBOL, removedSymbol}
}

export function setSidebarVisibility(isVisible) {
    return {type: SideBarVisibility.SET_SIDEBAR_VISIBILITY, isVisible}
}

export function setSchematicDocument(schematicDocument) {
    return {type: SchematicDocument.SET_SCHEMATIC_DOCUMENT, schematicDocument}
}